export default "../css/a6e0ecbd299b52db775a01c526dc8d3e.ttf";